import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

import { muiThemeLuma } from 'themes';

interface IconUtilitiesProps extends SvgIconProps {
  fill?: string;
}

const IconUtilities: React.FC<IconUtilitiesProps> = ({ fill, ...other }) => (
  <SvgIcon {...other}>
    <path
      d="M10 11.9999V19.9999H18V11.9999H10ZM0 19.9999H8V11.9999H0V19.9999ZM0 1.99994V9.99994H8V1.99994H0ZM13.66 0.689941L8 6.33994L13.66 11.9999L19.32 6.33994L13.66 0.689941Z"
      fill={fill || muiThemeLuma.palette.primary.main}
    />
  </SvgIcon>
);

export default IconUtilities;
